// extracted by mini-css-extract-plugin
export default {"container":"T6HQ0","title":"rdZyY","captcha":"LUZGL"};